import { render, staticRenderFns } from "./PrintBillK80V3.vue?vue&type=template&id=913a4270&scoped=true"
import script from "./PrintBillK80V3.vue?vue&type=script&lang=js"
export * from "./PrintBillK80V3.vue?vue&type=script&lang=js"
import style0 from "./PrintBillK80V3.vue?vue&type=style&index=0&id=913a4270&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913a4270",
  null
  
)

export default component.exports